"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProductListContainer = require("./ProductListContainer");
Object.keys(_ProductListContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductListContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductListContainer[key];
    }
  });
});
var _ProductListContainerSkeleton = require("./ProductListContainerSkeleton");
Object.keys(_ProductListContainerSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductListContainerSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductListContainerSkeleton[key];
    }
  });
});
